// extracted by css-extract-rspack-plugin
export default {"contentWrapper":"src-modules-auth-pages-SetPasswordPage-components-ContentWrapper-ContentWrapper-module__contentWrapper-DHdiVZ","loading":"src-modules-auth-pages-SetPasswordPage-components-ContentWrapper-ContentWrapper-module__loading-IhUSgy"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"contentWrapper\":\"src-modules-auth-pages-SetPasswordPage-components-ContentWrapper-ContentWrapper-module__contentWrapper-DHdiVZ\",\"loading\":\"src-modules-auth-pages-SetPasswordPage-components-ContentWrapper-ContentWrapper-module__loading-IhUSgy\"}";
        // 1793873552359
        var cssReload = require("../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  